export enum FeedbackPlatform {
  Web = 'web',
  IOS = 'ios',
  Android = 'android',
}